export const phoneNumber = '18883684689'

export const complaintPhoneNumber = '5124653789'

export const emailAddress = 'truckstop@txdmv.gov'

export const helpEmail = 'MCD_MCCS-Helpdesk@txdmv.gov'

export const mailingAddress =
  'TxDMV-MCD, 4000 Jackson Ave. Bldg 1, Austin, Texas 78731'
